import React, { Component } from 'react';
import DatePicker, { DisabledDays } from '~/UI/DatePicker/DatePicker';
import Portal from '~/UI/Portal/Portal';

import styles from './styles.less';

interface Props {
	disabledDays?: DisabledDays;
	value: Date | null;
	referenceRect: { left: number; top: number; bottom: number };
	onSelect(date: Date): void;
	onFocus(): void;
	onBlur(): void;
	onClose(event: MouseEvent): void;
}

export default class DatePickerInputPopover extends Component<Props> {
	static defaultProps = {
		value: null,
		referenceRect: null,
	};

	containerElement: HTMLDivElement | null = null;

	componentDidMount() {
		document.addEventListener('mousedown', this.handleDocumentClick, true);
	}

	componentWillUnmount() {
		document.removeEventListener('mousedown', this.handleDocumentClick, true);
	}

	handleDocumentClick = (event: MouseEvent) => {
		if (
			this.containerElement !== null &&
			event.target !== this.containerElement &&
			event.target instanceof HTMLElement &&
			!this.containerElement.contains(event.target)
		) {
			this.props.onClose(event);
		}
	};

	render() {
		const { disabledDays, value, referenceRect, onSelect, onFocus, onBlur } = this.props;
		const style: {
			position: 'absolute';
			left: number;
			top: number;
		} = {
			position: 'absolute',
			left: referenceRect.left,
			top: referenceRect.bottom,
		};

		return (
			<Portal>
				<div
					className={styles.popover}
					ref={(ref) => (this.containerElement = ref)}
					style={style}
					onBlur={onBlur}
					onMouseDown={onFocus}
					onMouseOut={onBlur}
				>
					<DatePicker disabledDays={disabledDays} value={value} onSelect={onSelect} />
				</div>
			</Portal>
		);
	}
}
